import { SampleTestInterface } from '../../interfaces/sample-test-panel';

export const user = $localize`User`;
export const sampleName = $localize`Sample Name`;
export const sampleDescription = $localize`Sample Description`;
export const sampleId = $localize`Sample ID`;
export const testPanelName = $localize`Test Panel Name`;
export const status = $localize`Status`;
export const completedOn = $localize`Completed On`;
export const panelName = $localize`Panel Name`;
export const analysisName = $localize`Analyses`;
export const createdOn = $localize`Created On`;
export const groupName = $localize`Project`;

export const displayedColumns: string[] = ['sampleName', 'user', 'groupName', 'analysisName', 'createdOn'];

export const displayedColumnLabels: string[] = [sampleName, user, groupName, analysisName, createdOn];
